import { useNavigate, useLocation } from "react-router-dom";
import UserMenu from "@/components/atoms/UserMenu";
import useAppStore from "@/stores/useAppStore";
import { SystemRoleEnum } from "@/types/enum";

function TopNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAppStore((s) => s.user);
  const resetAppStore = useAppStore((s) => s.resetAppStore);

  const handleLogout = () => {
    localStorage.removeItem("app_accessToken");
    localStorage.removeItem("app_refreshToken");
    resetAppStore();
    navigate("/");
  };

  const isProjectsPage = location.pathname === "/projects";
  const isAdminPage = location.pathname.startsWith("/admin");
  const showBackButton =
    !isProjectsPage &&
    !isAdminPage &&
    location.pathname.startsWith("/projects");

  // Check if user is admin
  const isAdmin =
    user?.systemRole === SystemRoleEnum.ADMIN ||
    user?.systemRole === SystemRoleEnum.SUPER_ADMIN;

  if (!user) return null;

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 w-full">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Left side: Brand and Back Button */}
          <div className="flex items-center space-x-4">
            {/* Brand Name */}
            <div className="flex-shrink-0">
              <button
                onClick={() => navigate("/projects")}
                className="text-lg sm:text-xl font-bold text-gray-900 hover:text-blue-600 transition-colors"
              >
                LogisticsTool
              </button>
            </div>

            {/* Back to Projects Button */}
            {showBackButton && (
              <button
                onClick={() => navigate("/projects")}
                className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                <span className="hidden sm:inline">Back to Projects</span>
                <span className="sm:hidden">Back</span>
              </button>
            )}

            {/* Admin Link */}
            {isAdmin && (
              <button
                onClick={() => navigate("/admin")}
                className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isAdminPage
                    ? "text-blue-600 bg-blue-50"
                    : "text-gray-600 hover:text-blue-600 hover:bg-blue-50"
                }`}
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                  />
                </svg>
                Admin
              </button>
            )}
          </div>

          {/* Right side: User Menu */}
          <div className="flex items-center">
            <UserMenu
              userName={user.name}
              userEmail={user.email}
              onLogout={handleLogout}
            />
          </div>
        </div>
      </div>
    </nav>
  );
}

export default TopNavigation;
